import React from 'react'
import { BsFileEarmarkPdfFill } from 'react-icons/bs'
import { MdDriveFolderUpload } from 'react-icons/md'
import { Avatar, Box, Button, Col, Dialog, FabButton, Flex, InputField, Row, SelectField, Typography } from '../../../../ppui'
import { STATUTORY_KYC_CONST } from '../statutory-kyc-const'

const KycUpdateModal = ({
    kycModal,
    ToggleKycModal,
    UpdateStatutory,
    alldocs,
    onChangeKYCdoc,
    checkDocName,
    DeleteSpecificFile,
    docs,
    handleButtonClick,
    handleFileChange,
    openFileInNewTab,
    fileInputRef,
    updateLoder
}) => {
    return (
        <Dialog
            title="KYC Document"
            closeButton={true}
            fullWidth
            maxWidth="sm"
            open={kycModal}
            onClose={ToggleKycModal}
            onSubmit={UpdateStatutory}
            btnLoading={updateLoder}
        >

            <Flex direction="column" gap={30}>
                {
                    alldocs?.map((item, index) => (
                        <Row rowGap key={index}>
                            <Col xs={6}>
                                <Flex gap={20}>
                                    <Box>
                                        <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" mb={"0"} color={"dark"}>
                                            {item?.document_type}
                                        </Typography>
                                        <Typography variant="h5" mb={"0"}>
                                            {item?.document_number}
                                        </Typography>
                                    </Box>
                                </Flex>
                            </Col>

                            <Col xs={6}>
                                <Flex gap={10}>
                                    <Button
                                        onClick={() => DeleteSpecificFile(index)}
                                        variant="filled"
                                        size="sm"
                                        color="danger"
                                    >
                                        Delete
                                    </Button>

                                    <Button
                                        onClick={() => openFileInNewTab(item?.attachment)}
                                        variant="filled"
                                        size="sm"
                                        color="primary"
                                    >
                                        View
                                    </Button>
                                </Flex>
                            </Col>
                        </Row>
                    ))
                }

                <Row rowGap>
                    <Col xs={12} sm={6}>
                        <SelectField
                            defaultValue={docs?.document_type}
                            options={[
                                { id: "Aadhaar Card", name: "Aadhaar Card", disabled: checkDocName("Aadhaar Card") },
                                { id: "Voter ID", name: "Voter ID", disabled: checkDocName("Voter ID") },
                                { id: "PAN Card", name: "PAN Card", disabled: checkDocName("PAN Card") },
                                { id: "Driving License", name: "Driving License", disabled: checkDocName("Driving License") },
                                { id: "Passport", name: "Passport", disabled: checkDocName("Passport") },
                                { id: "Bank Passbook", name: "Bank Passbook", disabled: checkDocName("Bank Passbook") },
                                { id: "Cancelled Cheque", name: "Cancelled Cheque", disabled: checkDocName("Cancelled Cheque") },
                                { id: "Experience Letter", name: "Experience Letter", disabled: checkDocName("Experience Letter") },
                                { id: "Offer Letter", name: "Offer Letter", disabled: checkDocName("Offer Letter") },
                                { id: "Education and Qualification Documents", name: "Education and Qualification Documents", disabled: checkDocName("Education and Qualification Documents") },
                                { id: "Marksheet/Transcript", name: "Marksheet/Transcript", disabled: checkDocName("Marksheet/Transcript") },
                                { id: "Salary Slip", name: "Salary Slip", disabled: checkDocName("Salary Slip") },
                            ]}
                            onChange={(e) => onChangeKYCdoc(e, "document_type")}
                            {...STATUTORY_KYC_CONST.document_type}
                        />
                    </Col>

                    <Col xs={12} sm={6}>
                        <InputField
                            value={docs?.document_number ? docs?.document_number : ""}
                            valueSinc={!!docs?.document_number}
                            onChange={(e) => onChangeKYCdoc(e, "document_number")}
                            {...STATUTORY_KYC_CONST.document_number}

                        />
                    </Col>

                    <Col sm={12}>
                        <FabButton
                            icon={<MdDriveFolderUpload />}
                            onClick={handleButtonClick}
                            shape="extended"
                            variant="contained"
                        >
                            Upload
                        </FabButton>


                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".png, .jpg, .jpeg, .doc, .docx, .pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                    </Col>

                </Row>
            </Flex>
        </Dialog>
    )
}

export default KycUpdateModal